import React from "react";
import { Search, X } from "lucide-react";

/**
 * Premium minimalist product search bar.
 * Controlled component — parent owns the query state.
 */
export const ProductSearch = ({
  value,
  onChange,
  onClear,
  placeholder = "Pesquisar produtos...",
  resultCount,
  testId = "product-search",
}) => {
  return (
    <div className="w-full max-w-2xl" data-testid={`${testId}-wrap`}>
      <label htmlFor={testId} className="sr-only">
        Pesquisar produtos
      </label>
      <div className="relative group">
        <span
          className="absolute inset-y-0 left-0 flex items-center pl-5 text-[var(--mn-dark)]/60 group-focus-within:text-[var(--mn-gold)] transition-colors"
          aria-hidden
        >
          <Search size={17} strokeWidth={1.8} />
        </span>
        <input
          id={testId}
          type="text"
          role="searchbox"
          inputMode="search"
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full h-14 pl-12 pr-12 bg-white border border-[var(--mn-line)] rounded-full text-[0.95rem] text-[var(--mn-black)] placeholder:text-[var(--mn-dark)]/55 shadow-[0_1px_2px_rgba(17,17,17,0.03)] focus:outline-none focus:border-[var(--mn-gold)] focus:shadow-[0_0_0_4px_rgba(153,101,21,0.10)] transition-all"
          data-testid={testId}
        />
        {value && (
          <button
            type="button"
            onClick={onClear}
            aria-label="Limpar pesquisa"
            className="absolute inset-y-0 right-0 flex items-center pr-5 text-[var(--mn-dark)]/60 hover:text-[var(--mn-gold)] transition-colors"
            data-testid={`${testId}-clear`}
          >
            <X size={16} strokeWidth={2} />
          </button>
        )}
      </div>
      {value && typeof resultCount === "number" && (
        <p
          className="mt-3 text-[0.72rem] uppercase tracking-[0.22em] font-medium text-[var(--mn-dark)]/70"
          data-testid={`${testId}-count`}
        >
          {resultCount === 0
            ? "0 resultados"
            : `${resultCount} ${resultCount === 1 ? "produto" : "produtos"} encontrado${resultCount === 1 ? "" : "s"}`}
        </p>
      )}
    </div>
  );
};

export default ProductSearch;
